import React, { useState, useEffect } from 'react';
import { Plus, UserCheck, Users } from 'lucide-react';

const getToken = () => localStorage.getItem('synapse_token');
const hdrs = () => ({ 'Authorization': 'Bearer ' + getToken(), 'Content-Type': 'application/json' });

export default function PainelAdmin() {
    const [clientes, setClientes] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [funcionarios, setFuncionarios] = useState([]);
    const [expanded, setExpanded] = useState(null);
    const [showForm, setShowForm] = useState(null);
    const [form, setForm] = useState({ nome: '', email: '', senha: '', role: 'admin' });
    const [msg, setMsg] = useState('');

    useEffect(() => { loadData(); }, []);

    async function loadData() {
        try {
            const [c, u, f] = await Promise.all([
                fetch('/api/clientes', { headers: hdrs() }).then(r => r.json()),
                fetch('/api/painel/usuarios', { headers: hdrs() }).then(r => r.json()),
                fetch('/api/funcionarios', { headers: hdrs() }).then(r => r.json())
            ]);
            setClientes(Array.isArray(c) ? c : []);
            setUsuarios(Array.isArray(u) ? u : []);
            setFuncionarios(Array.isArray(f) ? f : []);
        } catch (e) { console.error(e); }
    }

    async function criarUsuario(clienteId) {
        if (!form.nome || !form.email || !form.senha) { setMsg('Preencha todos os campos'); return; }
        try {
            const res = await fetch('/api/painel/usuarios', {
                method: 'POST', headers: hdrs(),
                body: JSON.stringify({ cliente_id: clienteId, nome: form.nome, email: form.email, senha: form.senha, role: form.role })
            });
            const data = await res.json();
            if (!res.ok) { setMsg(data.error || 'Erro'); return; }
            setMsg('Usuario criado com sucesso!');
            setForm({ nome: '', email: '', senha: '', role: 'admin' });
            setShowForm(null);
            loadData();
            setTimeout(() => setMsg(''), 3000);
        } catch (e) { setMsg(e.message); }
    }

    const sty = {
        card: { background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 12, marginBottom: 16 },
        head: { padding: '18px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' },
        body: { padding: '0 24px 20px', borderTop: '1px solid var(--border)' },
        badge: { padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, display: 'inline-block' },
        green: { background: 'rgba(34,197,94,.15)', color: '#22c55e' },
        purple: { background: 'rgba(127,119,221,.15)', color: '#7f77dd' },
        red: { background: 'rgba(239,68,68,.15)', color: '#ef4444' },
        row: { display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', borderBottom: '1px solid var(--border)' },
        input: { padding: '9px 14px', background: 'var(--bg-primary)', border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text-primary)', fontSize: 13, outline: 'none', flex: 1 },
        sel: { padding: '9px 14px', background: 'var(--bg-primary)', border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text-primary)', fontSize: 13 },
        btn: { padding: '9px 18px', background: 'var(--purple-500)', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 6 },
        avatar: { width: 32, height: 32, borderRadius: '50%', background: 'linear-gradient(135deg, var(--purple-500), var(--purple-300))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 13, flexShrink: 0 }
    };

    return (
        <div>
            <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}>MyTime — Gestao de acessos</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: 14, marginBottom: 24 }}>Gerencie os acessos dos clientes ao painel</p>
            {msg && <div style={{ padding: '10px 16px', background: 'rgba(34,197,94,.15)', color: '#22c55e', borderRadius: 8, marginBottom: 16, fontSize: 13 }}>{msg}</div>}

            {clientes.filter(c => c.ativo !== false).map(cliente => {
                const usrs = usuarios.filter(u => u.cliente_id === cliente.id);
                const funcs = funcionarios.filter(f => f.cliente_id === cliente.id && f.ativo);
                const isOpen = expanded === cliente.id;
                return (
                    <div key={cliente.id} style={sty.card}>
                        <div style={sty.head} onClick={() => setExpanded(isOpen ? null : cliente.id)}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{ fontSize: 16, fontWeight: 600 }}>{cliente.nome}</span>
                                <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>{cliente.segmento || ''}</span>
                            </div>
                            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                <span style={{ ...sty.badge, ...sty.purple }}>{funcs.length} agente{funcs.length !== 1 ? 's' : ''}</span>
                                <span style={{ ...sty.badge, ...sty.green }}>{usrs.length} acesso{usrs.length !== 1 ? 's' : ''}</span>
                                <span style={{ fontSize: 18, color: 'var(--text-muted)' }}>{isOpen ? '\u25BE' : '\u25B8'}</span>
                            </div>
                        </div>
                        {isOpen && (
                            <div style={sty.body}>
                                <div style={{ marginTop: 16 }}>
                                    <div style={{ fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, color: 'var(--text-muted)', marginBottom: 10 }}>Agentes vinculados</div>
                                    {funcs.length === 0 ? <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>Nenhum agente ativo</p> : funcs.map(f => (
                                        <div key={f.id} style={{ ...sty.row, gap: 16 }}>
                                            <div style={sty.avatar}>{(f.nome || '?')[0].toUpperCase()}</div>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontWeight: 500, fontSize: 14 }}>{f.nome}</div>
                                                <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{f.whatsapp_numero || 'Sem numero'}</div>
                                            </div>
                                            <span style={{ ...sty.badge, ...(f.whatsapp_conectado ? sty.green : sty.red) }}>{f.whatsapp_conectado ? 'Conectado' : 'Desconectado'}</span>
                                        </div>
                                    ))}
                                </div>
                                <div style={{ marginTop: 20 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                        <div style={{ fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, color: 'var(--text-muted)' }}>Acessos ao painel MyTime</div>
                                        <button style={{ ...sty.btn, fontSize: 12, padding: '6px 14px' }} onClick={(e) => { e.stopPropagation(); setShowForm(showForm === cliente.id ? null : cliente.id); }}><Plus size={14}/> Novo acesso</button>
                                    </div>
                                    {usrs.map(u => (
                                        <div key={u.id} style={sty.row}>
                                            <UserCheck size={16} style={{ color: 'var(--text-muted)' }}/>
                                            <span style={{ fontWeight: 500, fontSize: 14, flex: 1 }}>{u.nome} <span style={{ fontSize: 12, color: 'var(--text-muted)', marginLeft: 6 }}>{u.email}</span></span>
                                            <span style={{ ...sty.badge, ...sty.purple }}>{u.role}</span>
                                            <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{u.ultimo_login ? new Date(u.ultimo_login).toLocaleDateString('pt-BR') : 'Nunca acessou'}</span>
                                        </div>
                                    ))}
                                    {usrs.length === 0 && showForm !== cliente.id && <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>Nenhum acesso criado</p>}
                                    {showForm === cliente.id && (
                                        <div style={{ marginTop: 14, padding: 16, background: 'var(--bg-primary)', borderRadius: 10, border: '1px solid var(--border)' }}>
                                            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
                                                <input style={sty.input} placeholder="Nome" value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })}/>
                                                <input style={sty.input} placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}/>
                                            </div>
                                            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
                                                <input style={sty.input} type="password" placeholder="Senha" value={form.senha} onChange={e => setForm({ ...form, senha: e.target.value })}/>
                                            </div>
                                            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                                <select style={{...sty.sel, flex:1}} value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}><option value="admin">Admin</option><option value="operador">Operador</option></select>
                                                <button style={sty.btn} onClick={() => criarUsuario(cliente.id)}>Criar</button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
